import GeneralForm from "components/GeneralForm";
import { hideLoading } from "components/Loading";
import { showLoading } from "components/Loading";
import { validate } from "components/validateGeneralForm";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Button, Modal, ModalBody } from "reactstrap";
import ordemServicoService from "services/OrdemServicoService";
import { erroInesperado } from "services/Utils";

export default function ModalAlterarGarantia({ config, onClosed }) {
  const [data, setData] = useState({})

  useEffect(() => {
    if (config) {
      setData({
        prazoGarantiaMeses: config.prazoGarantiaMeses
      })
    } else {
      setData({})
    }
  }, [config])

  const formConfig = [
    [
      {
        name: "prazoGarantiaMeses", label: 'Garantia (meses)', type: "radio", required: true, colspan: 12,
        options: [3, 6, 12, 18, 21, 24].map(v => ({ value: v, label: `${v}` }))
      },
    ]
  ]

  const handleChange = (name, value) => {
    setData({ ...data, [name]: value })
  }

  const handleSubmit = async (ev) => {
    ev.preventDefault()

    const errors = validate(formConfig, data)
    if (errors.length > 0) {
      setData({ ...data, errors })
      return
    }

    try {
      showLoading()
      await ordemServicoService.alterarGarantiaMovimentacao(config.idOrdemServico, config.idItem, config.idMovimentacao, data.prazoGarantiaMeses)
      hideLoading()
      toast('Registro alterado com sucesso!')
      config.onChanged && config.onChanged()
      onClosed && onClosed()
    } catch (ex) {
      hideLoading()
      erroInesperado()
    }
  }

  return (
    <Modal isOpen={!!config} size="lg">
      <ModalBody>
        <h2>Alterar Garantia</h2>
        <hr />
        <form onSubmit={handleSubmit}>
          <GeneralForm
            config={formConfig}
            data={data}
            onChange={handleChange}
            disabled={false}
          />

          <div className="text-right mt-4">
            <Button type="submit" color="primary">Salvar</Button>
            <Button type="button" color="primary" outline onClick={onClosed}>Cancelar</Button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  )
}
